import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import type ja from "./locales/ja.json";

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: { translation: typeof ja };
  }
}

i18n.use(initReactI18next).init({
  resources: {},
  lng: "ja",
  fallbackLng: "ja",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
